export const Brand_Images = [
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/blt13b0f02cd71877df/5f08974a8b0e59084c9f7570/hd-logo-v3.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/bltac334446d6f9e89c/5f96fc4f2425cd7a8af6845e/pmall_svg-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/bltf0b1021465476e4f/5f08974b0d1d2008538ce15a/SharisLogo_r.svg?height=32&width=78",
  },

  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/bltef2e14ec247ab827/5f08974a2cd8e87f92bdd257/fb-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/blt71adcb0696952e83/5f08974baa5d1801639286b4/sch-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/blte1e2eb25cfd09fb6/5f08974a91afb901b86d5251/cco-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/bltf9903ccf2408c217/5f0897552cd8e87f92bdd25b/tpf-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/blt7ef824d3f9f5074d/5f0897558b0e59084c9f7574/wlf-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/blta2ba2ac7606f6c15/5f08974bceebbf7e87c30215/sy-logo-v2.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt0281495b20b504a0/blta4f709f645453ff0/61b4eeeea000c90ecc6e15bd/VC_Logo_w_tag.svg?height=32&width=78",
  },
  {
    img: "https://images.contentstack.io/v3/assets/blt95e0138311135214/bltac303abaae751c40/5f08974af394777f87099a07/18b-logo-v2.svg?height=32&width=78",
  },
];


export const Categories_Data = [
  {
    category:"VALENTINE'S",
    url:"/ind/valentine"
  },
  {
    category:"BIRTHDAY",
    url:"/ind/birthday"
  },
  {
    category:"SYMPATHY",
    url:"/ind/sympathy"
  },
  {
    category:"OCCASION",
    url:"/ind/anniversary"
  },
  {
    category:"FLOWERS",
    url:"/ind/plants"
  },
  {
    category:"PLANTS",
    url:"/ind/plants"
  },
  {
    category:"GIFT BASKETS & FOOD",
    url:"/ind/Gift Baskets"
  },
  {
    category:"GIFTS & MORE",
    url:"/ind/sameday delivery"
  },
  {
    category:"SAME-DAY DELIVERY",
    url:"/ind/sameday delivery"
  },
  {
    category:"SALE",
    url:"/ind/sale"
  },
  {
    category:"COMMUNITY",
    url:"/ind/sale"
  },
]

const Flower_Data1 = [
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt5eb232318d3a6d1e/637e8388deb37610ecbb8e31/flower-delivery-same-day-silo-167891-260x284.jpeg?quality=75&auto=webp&optimize={medium}",
    name:'Same Day Delivery'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt26149ee749ecd0f3/62b5c27fa7c4490fd2ef03ef/magnificent-preserved-roses-silo-156623-260x284.jpeg?quality=75&auto=webp&optimize={medium}",
    name:'Love and Romance'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt867d5477b7adc192/627be2023debbf3afdd2ea1e/get-well-flowers-146761-silo-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Get Well'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt358c381bc15c10ef/63bdb18a2effe86502073b30/chocolate-covered-strawberries-delivery-silo-192546-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Chocolate Covered'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt180dd3fd2c5f4596/63bdb1a3ee0cf115ce1fc07c/just-because-flowers-silo-90577mprsv1-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Just Because'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcd2ef4bf9ed156ee/632de66c5710672259b3c66b/new-baby-flowers-silo-177706yw-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'New Baby'
  },
]

export const Flower_Data2 = [
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt2a407a6a54d38487/63c1ce615156964aea4347db/funeral-arrangements-silo-148752-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Funeral Arrangements'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt29d030cbcfd4ab4e/61ce05c18ae3ee7d4c156b19/classic-all-white-arrangement-sympathy-95097-silo-260x284.jpeg?quality=75&auto=webp&optimize={medium}",
    name:'For The Family'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltea2dacf314796c21/63c1ce906bf00e62d437f92d/sympathy-plants-silo-101980-260x284.jpeg?quality=75&auto=webp&optimize={medium}",
    name:'Plants'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt7c9e9d4a2198fa1e/63c1ceb606d8a07b811ae1e3/sympathy-same-day-delivery-silo-148685-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Same Day Delivery'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt5dcd51ccaacd3721/63c1ceef881b107c49c5e885/gift-baskets-sympathy-silo-96275dx-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Gift Baskets'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt1e51da89f5d53b69/63c1cf15e6cd4a7779d9f21b/sympathy-remembrance-gifts-silo-97343l-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Remembrance Gifts'
  },
]
export const Flower_Data3 = [
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt83c25a21462cccea/63a61e2e9233961262fbbcfe/spa-gift-basket-silo-mk012144-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Spa Gifts'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt8ccd8ba5f57bb6c5/63a61e6a66600623830ad5b8/candle-gifts-lanterns-silo-mk021324-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Candles & Lanterns'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt204357e08752a3bc/63a61ea27760ab1f00affbb1/gifts-under-25-silo-mk018491-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Gifts under $25'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt0c60554654188a74/63a61ee81d30ec7c2c531c79/zen-gifts-for-relaxation-silo-mkq016474-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Zen & Relaxation'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt9f97ed604bf1a128/63a61f39609d40109bf54fe8/lavender-flowers-gifts-silo-155227-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Lavender Gifts'
  },
  {
    img:"https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt590656ac79c533bf/63a630b99233961262fbbd0a/cozy-comfort-gifts-silo-mk005330-260x284.jpg?quality=75&auto=webp&optimize={medium}",
    name:'Cozy Comfort'
  },
]


export const ReviewData = [
  {
    img:'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt4c9be4e2d955776a/602a81580aba282006983f75/hp-reviews-final-167891.png?quality=70&auto=webp&optimize={medium}',
    rating:'Beautiful',
    des:"I bought these for my Nana's birthday he said they were amazingly beautiful!",
    name:'-Pamela'
  },
  {
    img:'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt2b874f93791fce4a/62b09064482ba357e65ddbe8/web_icons_125x125_ocean_breeze_orchids.png?quality=70&auto=webp&optimize={medium}',
    rating:'Best Flowers',
    des:"These flowers are beautiful and just as vibrant as the picture. One of the most beautiful bouquets I have ever seen!",
    name:'-Michelle'
  },
  {
    img:'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltfff372650000728b/6259ada700a8bb4b77960c3b/web_icons_125x125_classic_budding_rose.png?quality=70&auto=webp&optimize={medium}',
    rating:'Very Happy',
    des:"I love how the recipient can plant the roses and enjoy them for a long time. The plant is healthy and the candle ordered with it smells great!",
    name:'-Betty'
  },
  {
    img:'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt854645311f2a8ec4/621cf518ba043c4a2c4a9a54/web_icons_125x125_Gourmet_Drizzled_Berries-v2.png?quality=70&auto=webp&optimize={medium}',
    rating:'Sweet Anniversary',
    des:"The strawberries arrived on time and were fantastic as always. Definitely made my anniversarya lot sweeter!",
    name:'-Brian'
  },
]





export default Flower_Data1;